export default __webpack_public_path__ + "static/media/no-data.794521d1.webp";